import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-danger my-1"
}
const _hoisted_2 = { class: "dialog-footer" }

import { ref } from "vue";
import EventsServices from "../../services/EventsServices";
import { ElNotification } from "element-plus";
import i18n from "@/core/plugins/i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'AddTrackingModal',
  emits: ["fetch-data"],
  setup(__props, { expose: __expose, emit: emits }) {

const t = i18n.global.t;
const isLoading = ref(false);
const dialogRef = ref(false);
const trackingNumber = ref("");
const data = ref<any>({});
const showError = ref(false);
const checkTrackingNumber = () => {
  showError.value = trackingNumber.value.trim().length === 0;
};
const show = (_data: any) => {
  dialogRef.value = true;
  data.value = _data;
};

const submit = async () => {
  isLoading.value = true;
  try {
    checkTrackingNumber();
    if (showError.value) {
      isLoading.value = false;
      return;
    }
    await EventsServices.addTrackingNumber(data.value.id, {
      trackingNumber: trackingNumber.value,
    });
    await EventsServices.shipOrder(data.value.id);
    ElNotification({
      title: t("status.success"),
      message: t("status.success"),
      type: "success",
    });
    emits("fetch-data");
    hide();
  } catch (error) {
    console.log(error);
  }
  isLoading.value = false;
};

const hide = () => {
  dialogRef.value = false;
  trackingNumber.value = "";
  showError.value = false;
};

__expose({
  show,
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: dialogRef.value,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((dialogRef).value = $event)),
    title: _unref(t)('action.addTrackingNumber'),
    width: "500",
    "align-center": "",
    "before-close": hide
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_button, {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (dialogRef.value = false)),
          disabled: isLoading.value
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("action.cancel")), 1)
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_el_button, {
          type: "primary",
          loading: isLoading.value,
          onClick: submit
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("action.confirm")), 1)
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_input, {
        modelValue: trackingNumber.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((trackingNumber).value = $event)),
        placeholder: _unref(t)('action.addTrackingNumber'),
        disabled: isLoading.value
      }, null, 8, ["modelValue", "placeholder", "disabled"]),
      (showError.value)
        ? (_openBlock(), _createElementBlock("label", _hoisted_1, _toDisplayString(_ctx.$t("title.fillRequiredInfo")), 1))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})